import React, { useCallback, memo } from 'react'
import { useNavigate } from 'react-router-dom'

import LoadingButton from '@mui/lab/LoadingButton'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import { ROUTES } from '../../../constants/routes'
import { usePostImportMutation } from '../slice'

const PostImport = ({ imported: { id }, open, setOpen }) => {
  const [postImport, { isLoading }] = usePostImportMutation()
  const navigate = useNavigate()

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [setOpen])

  const handleImport = useCallback(async () => {
    await postImport({ importId: id })
    setOpen(false)
    navigate(ROUTES.PROSPECTS_IMPORTS)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postImport])

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Perform this import?</DialogTitle>
      <DialogContent>
        <DialogContentText>If you perform this import, all records will be imported as prospects.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <React.Fragment>
          <LoadingButton disabled={isLoading} onClick={handleClose} autoFocus>
            Cancel
          </LoadingButton>
          <LoadingButton loading={isLoading} onClick={handleImport}>
            Import
          </LoadingButton>
        </React.Fragment>
      </DialogActions>
    </Dialog>
  )
}

const MemoizedPostImport = memo(PostImport)
MemoizedPostImport.displayName = 'PostImport'

export default MemoizedPostImport
